import getWebSlugsAndConfig from "~/utils/getWebSlugsAndConfig";

// saveFilter/filterId are only declared by the filter components. Reading them
// straight off any other bound component would trip Vue's "accessed during
// render but is not defined on instance" warning, so probe with `in` first —
// that goes through the proxy's `has` trap, which stays quiet.
function optionalContextValue(context, key) {
    return context && key in context ? context[key] : undefined;
}

function getGlobalFilterQueryIdentifier() {
    const isUser = this.$route.name === 'admin-accounts-accountSlug-projectSlug-participant-user';
    const {user} = this.$route.params;
    const isForumPreview = this.$route.name?.includes('taskSlug-setup-forum') || false;
    const {projectSlug, accountSlug} = getWebSlugsAndConfig.bind(this)();
    const saveFilter = optionalContextValue(this, 'saveFilter');
    const filterId = optionalContextValue(this, 'filterId');
    let queryIdentifier;

    //Give the forum preview a different identifier to prevent it using the analysis filter
    if(isForumPreview){
        queryIdentifier = `forum-preview-${projectSlug}`;
    }
    else if(!saveFilter && filterId){
        queryIdentifier = filterId;
    }
    else if(!projectSlug && !isUser){
        queryIdentifier = accountSlug ? `${accountSlug}` : 'global';
    }else{
        queryIdentifier = isUser ? `${projectSlug}_${user}` : `${projectSlug}`;
    }
    return queryIdentifier;
};

export default getGlobalFilterQueryIdentifier;
